module.exports = __webpack_public_path__ + "static/media/close.0ced4a5c.svg";